<template>
  <!--==================
    component shows all new reviews in review page (admin)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <div v-if="!reviews.length" class="alert alert-info col text-center mt-4" role="alert">
      <span class="font-italic">no new review found!</span>
    </div>

    <div id="accordion2">
      <div v-for="(review, index) in reviews" :key="review.id" class="col">
        <div class="card-header px-0" :id="'heading-' + review.id">
          <h5 class="mb-0">
            <button
              @click="navigateReview($event)"
              class="btn btn-link col text-left"
              data-toggle="collapse"
              :data-target="'#collapse-' + review.id"
              aria-expanded="true"
              :aria-controls="'collapse-' + review.id"
            >
              <div class="d-flex align-items-center justify-content-between">
                <span
                  >{{ review.title }} | By <em>{{ review.fullName }}</em></span
                >
                <span>{{ review.operator.companyName }}</span>
              </div>
            </button>
          </h5>
        </div>

        <div
          :id="'collapse-' + review.id"
          class="collapse review-list"
          :aria-labelledby="'heading-' + review.id"
          data-parent="#accordion2"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="review-info-left">
              <div class="">
                <span>{{ review.createdAt }} | By</span>
                <em>{{ review.fullName }}</em>
              </div>
              <div class="d-flex align-items-center">
                <span>Rating:</span>
                <div class="stars">
                  <i
                    :class="
                      review.rate > 0 && review.rate <= 0.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 0.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                  <i
                    :class="
                      review.rate > 1 && review.rate <= 1.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 1.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                  <i
                    :class="
                      review.rate > 2 && review.rate <= 2.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 2.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                  <i
                    :class="
                      review.rate > 3 && review.rate <= 3.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 3.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                  <i
                    :class="
                      review.rate > 4 && review.rate <= 4.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 4.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                </div>
                <span class="font-weight-bold">{{ review.rate }}</span
                >&nbsp;/ 5 stars
              </div>
            </div>
            <div class="review-info-right">
              <div class="d-block">
                <h6 class="mb-3">
                  <a class="text-primary" :href="operatorUrl + review.operator.id" target="_blank">{{
                    review.operator.companyName
                  }}</a>
                </h6>
              </div>
              <div class="d-block">
                <button
                  @click="publish($event)"
                  :data-id="review.id"
                  :data-index="index"
                  class="btn btn-sm btn-success mr-4"
                >
                  publish review
                </button>
                <button
                  @click="removeReview($event)"
                  class="btn btn-sm btn-primary mr-4"
                  :data-id="review.id"
                  :data-index="index"
                >
                  delete review
                </button>
              </div>
            </div>
          </div>
          <div class="review">
            <strong>{{ review.title }}</strong>
            <p class="mt-2">{{ review.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "NewReview",

  computed: {
    ...mapGetters(["newReviews"]),

    reviews() {
      return this.newReviews;
    },

    operatorUrl() {
      return process.env.VUE_APP_OPERATOR_URL;
    },
  },

  mounted() {
    this.fetchNewReviews();
  },

  methods: {
    ...mapActions(["fetchNewReviews", "publishReview", "deleteReview"]),

    async publish(e) {
      let id = e.target.getAttribute("data-id");
      this.publishReview(id);
    },

    removeReview(e) {
      e.preventDefault();

      let id = e.target.getAttribute("data-id");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this review?",
        buttons: {
          confirm: () => {
            dP.deleteReview({ id, tag: "new" });
          },
          cancel: () => {},
        },
      });
    },

    navigateReview(e) {
      setTimeout(() => {
        $("html, body").animate(
          {
            scrollTop: $(e.target).offset().top - 40 + "px",
          },
          500
        );
      }, 1000);
    },
  },
};
</script>
